// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"517045ff","334":"bea40801","1052":"9a0055a0","5070":"99a588b9","9376":"9a0055a0"}[chunkId] + ".chunk.css";
};